<div *ngIf="form" class="form-container" [ngClass]="{ 'no-error': !hasErrors(), 'has-error': hasErrors() }">
  <mat-label *ngIf="label" [ngClass]="{ focused: isFocused, 'has-error': hasErrors() }" class="form-label">{{
    label
  }}</mat-label>
  <div class="content-container">
    <ckeditor
      *ngIf="show"
      fxFlex="99"
      [editor]="editor"
      [ngModel]="data"
      [config]="config"
      (ready)="onReady($event)"
      (change)="onChange($event)"
      (blur)="blur.emit()"
    >
    </ckeditor>
    <mat-error *ngIf="hasErrors()" [@elementSlideDown]> {{ capitalizedField }} is required </mat-error>
  </div>
</div>
